import {PasswordField} from "../../components/widgets/PasswordField";
import * as React from "react";
import {useState} from "react";
import {ButtonAction} from "../../components/widgets/ButtonAction";
import {FormElement} from "../shared/FormElement";
import {UIStateVendor} from "../../data/UIStateVendor";

import './LoginPanel.pcss';

interface Props {
  loginErrorMessage:string;
}

export const LoginPanel = (props:Props) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [pleaseWait, setPleaseWait] = useState(false);
  const [loginError, setLoginError] = useState(props.loginErrorMessage);

  function login() {
    UIStateVendor.attemptLogin(email, password)
      .catch((err)=>{
        if(err && err.hasOwnProperty('userMessage')) {
          setLoginError(err.userMessage);
        } else {
          setLoginError("Sign in failed. Please try again.")
        }
      });
  }

  return (
      <div className={"login-panel"}>
        <h2 className={'level2'}>Sign in</h2>
        {loginError && <p className={'loginError'}>{loginError}</p> }
        <FormElement label={'Email'} disabled={pleaseWait} value={email} onChange={setEmail} invalidReason={''}/>
        <div className={`form-element${passwordInvalid?' invalid':''}`}>
          <label htmlFor={'password'}>Password</label>
          <PasswordField
              id="password"
              required
              invalid={passwordInvalid}
              inputName="password"
              password={password}
              onPasswordChange={setPassword}
              hideStrengthHint
          />
        </div>

        <ButtonAction buttonActionIsBroken onClick={login} className={"cta-button noselect"}>{pleaseWait ? "Please Wait" : "Sign In"}</ButtonAction>

      </div>
  )
}